export var buildEnv = {
  sdkVersion: __BUILD_ENV__SDK_VERSION__,
  sdkName: 'df_web_rum_sdk'
}
